"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "expandInputPatterns", {
    enumerable: true,
    get: function() {
        return expandInputPatterns;
    }
});
function expandInputPatterns(patterns, target, dependencyMap) {
    const expandedPatterns = {};
    for (const pattern of patterns){
        if (pattern.startsWith("^") || pattern.startsWith("!^")) {
            const matchPattern = pattern.replace("^", "");
            // get all the packages that are transitive deps and add them to the list
            const queue = [
                target.packageName
            ];
            const visited = new Set();
            while(queue.length > 0){
                const pkg = queue.pop();
                if (visited.has(pkg)) {
                    continue;
                }
                visited.add(pkg);
                if (pkg !== target.packageName) {
                    expandedPatterns[pkg] = expandedPatterns[pkg] ?? [];
                    expandedPatterns[pkg].push(matchPattern);
                }
                if (dependencyMap.dependencies.has(pkg)) {
                    const deps = dependencyMap.dependencies.get(pkg);
                    if (deps) {
                        for (const dep of deps){
                            queue.push(dep);
                        }
                    }
                }
            }
        } else {
            const pkg = target.packageName;
            expandedPatterns[pkg] = expandedPatterns[pkg] ?? [];
            expandedPatterns[pkg].push(pattern);
        }
    }
    return expandedPatterns;
}
